import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Collapse from '@material-ui/core/Collapse'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { red } from '@material-ui/core/colors'
import FavoriteIcon from '@material-ui/icons/Favorite'
import ShareIcon from '@material-ui/icons/Share'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Grid, Chip } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: red[500],
    margin: 'auto'
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  withBreakpoints: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: '10rem'
    }
  }
}))

export default function UserCard (props) {
  const classes = useStyles()
  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar
            aria-label='avatar'
            src={props.imageUrl}
            className={classes.avatar}
          />
        }
        action={
          <IconButton
            aria-label='settings'
            onClick={e => props.actions(e.currentTarget)}
          >
            {props.actionIcon ? props.actionIcon : <MoreVertIcon />}
          </IconButton>
        }
        title={
          <Typography
            variant='subtitle1'
            noWrap
            className={[classes.capitalize, classes.withBreakpoints]}
          >
            {props.name}
          </Typography>
        }
        subheader={
          <>
            <Typography
              variant='subtitle2'
              noWrap
              className={classes.withBreakpoints}
            >
              {props.email}
            </Typography>
            <Typography
              variant='subtitle2'
              color='secondary'
              component='subtitle2'
            >
              {props.role}
            </Typography>
            <br />
            {props.departments.map(dep => (
              <Chip
                color='primary'
                className={classes.withBreakpoints}
                size='small'
                label={dep.centerName}
                style={{
                  marginTop: '.5rem',
                  marginRight: '.5rem'
                }}
              />
            ))}
          </>
        }
      />
    </Card>
  )
}
